const initialState = {
  user: undefined,
  userInfo: {},
  errors: {},
  message: {},
  authenticated: false
}

export default (state=initialState, action) => {
  switch(action.type) {
    case "LOGIN_ERROR":
      return Object.assign({}, state, { errors: { loginError: "Usuário e/ou senha incorreto"}})
    case "GET_USER_SUCCESS":
      return Object.assign({}, state, { userInfo: action.response })
    case "ADD_USER_FAIL":
      return Object.assign({}, state, {errors: {addUser: action.response}})
    case "RECOVER_PASSWORD_SUCCESS":
      return Object.assign({}, state, {message: {changePassword: "Nova senha enviada!" }})
    case "RECOVER_PASSWORD_FAIL":
      return Object.assign({}, state, {errors: {changePassword: action.response + "! Preencha o campo Usuário"}})
    case "CHANGE_PASSWORD_SUCCESS":
      return Object.assign({}, state, {message: {changePassword: action.response }})
    case "CHANGE_PASSWORD_FAIL":
      return Object.assign({}, state, {errors: {changePassword: action.response }})
    case "RESET_ERRORS":
      return Object.assign({}, state, {errors: {}})
    default:
      return state
  }
}
